import { DefaultTheme } from "styled-components";
import { informationsRouteList, routeList, settingsRouteList } from "../App";
import { storageKey } from "../configs/config";
import { resetMixpanel } from "./mixpanel";

// Convert image URL to a File object
export const urlToFile = async (url: string, filename: string): Promise<File> => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], filename, { type: blob.type });
};

export const getVpFontSize = (viewportWidth: number, pourcentage: number): string => {
  return (viewportWidth * pourcentage) / 100 + "px";
};

export const randomizeList = <T>(list: T[]): T[] => list.sort(() => Math.random() - 0.5);

export const isSafari = () => {
  const ua = navigator.userAgent;

  // Vérification spécifique à Safari
  return (
    /Safari/i.test(ua) && !/Chrome/i.test(ua) // Exclut Chrome qui utilise aussi Webkit
  );
};

export const resetLocalEnv = () => {
  localStorage.removeItem(storageKey.accessToken);
  localStorage.removeItem(storageKey.refreshToken);
  localStorage.removeItem(storageKey.deviceToken);
  resetMixpanel();
};

export const getBackgroundColor = (pathname: string, theme: DefaultTheme) => {
  const isPrimaryPage = [
    routeList.informations,
    routeList.matchHappening,
    routeList.warningMatch,
    informationsRouteList.dogBodyLanguage,
    informationsRouteList.tipsAndAdvice,
  ].includes(pathname);

  const isPrimaryChillPage = [informationsRouteList.faq, informationsRouteList.theCynoMethod, routeList.chatWith].some(
    (route) => pathname.startsWith(route)
  );

  const isTertiaryPage = [settingsRouteList.termOfUse].includes(pathname);

  if (isPrimaryPage) return theme.color.primary;
  if (isPrimaryChillPage) return theme.color.primaryChill;
  if (isTertiaryPage) return theme.color.tertiary;

  return theme.color.primaryExtraLight;
};

export function getVisitorId(): string {
  // Use a fixed ID in local dev (via npm run xxx) to avoid polluting analytics / Sentry with random UUIDs
  if (import.meta.env.DEV) {
    return "local-visitor-id";
  }

  const key = "visitor_id";
  let id = localStorage.getItem(key);

  if (!id) {
    // crypto.randomUUID() is only available in secure contexts (HTTPS) and modern browsers (Chrome 92+)
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      id = crypto.randomUUID();
    } else {
      // Fallback for older browsers/environments (e.g. Chrome WebView < 92)
      id = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c: any) =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
      );
    }
    localStorage.setItem(key, id);
  }

  return id;
}
